import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/atendimento-triagem`

    const headers = { responseType: "arraybuffer" }

    return {
        guiaEncaminhamento(atendimentoId, queryParms = {}) {
            return atendimentoId
                ? repository.get(`${baseUrl}/guia-encaminhamento/${atendimentoId}`, headers)
                : repository.get(`${baseUrl}/guia-encaminhamento?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}
